import _u from 'underscore';
import { PRODUCT_DB_API_LABEL_FORMATTER, PRODUCT_DB_API_LEVEL_BY_SERVICES } from '../constants/constants';

/**
 * Returns array of options to supply react select options.
 * Processes labels on per product ID basis.
 *
 * @param {number} productId
 * @param {object[]} tariffs
 * @return {*[]}
 */
export default (productId, tariffs) => {
    let options = [];
    // For DB API - perform grouping by custom levels.
    if (productId === 2) {
        const levels = PRODUCT_DB_API_LEVEL_BY_SERVICES.sort((a, b) => b.amount - a.amount);
        _u.each(_u.sortBy(tariffs, 'services'), (tariff) => {
            const level = _u.find(levels, level => tariff?.services >= level.amount);
            let groupLabel = `Level ${level.id}`;
            let optionLabel = tariff.name;
            const match = PRODUCT_DB_API_LABEL_FORMATTER.match.exec(tariff.name);
            if (match) {
                groupLabel = PRODUCT_DB_API_LABEL_FORMATTER.replacer(PRODUCT_DB_API_LABEL_FORMATTER.groupLabel, match);
                optionLabel = PRODUCT_DB_API_LABEL_FORMATTER.replacer(PRODUCT_DB_API_LABEL_FORMATTER.optionLabel, match);
            }

            const group = options[level.id] ?? { label: groupLabel, options: [] };
            tariff.name = optionLabel;
            group.options.push(tariff);
            options[level.id] = group;
        });
    } else {
        const tariffsSubscribable = tariffs?.filter((tariff) => !!tariff?.subscribable)
        const tariffsLegacy = tariffs?.filter((tariff) => !tariff?.subscribable);
        const tariffsAnnual = tariffsSubscribable?.filter((tariff) => tariff?.billing_period === 'Year');
        const tariffsMonthly = tariffsSubscribable?.filter((tariff) => tariff?.billing_period === 'Month');

        options = [
            {
                label: 'Annual',
                options: tariffsAnnual,
            },
            {
                label: 'Monthly',
                options: tariffsMonthly,
            },
            {
                label: 'Old packages',
                options: tariffsLegacy,
            },
        ];
    }

    return options;
}
